"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('oceanengine', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M22.0382 2.00146C21.8693 2.00146 21.7647 2.18984 21.8484 2.34333L31.3047 19.5759V19.5773L34.2921 7.84658C34.3354 7.67077 34.3117 7.4824 34.2265 7.32612L31.3047 2.00146H22.0382ZM9.60561 6.39402L4.97166 14.8387C4.88794 14.9922 4.99259 15.1833 5.16003 15.1833H24.0712L9.60561 6.39402L24.0712 15.1833L15.9098 6.59635C15.7884 6.46658 15.621 6.39402 15.4479 6.39402H9.60561ZM40.761 11.1312L31.3047 28.3638L42.4521 25.2215C42.6196 25.174 42.7605 25.0596 42.847 24.9019L45.7703 19.5773V19.5759L41.1377 11.1312C41.0945 11.0559 41.0219 11.0168 40.9493 11.0168C40.8754 11.0168 40.8014 11.0559 40.761 11.1312ZM5.69026 22.721C5.52282 22.7656 5.38049 22.8829 5.29398 23.0391L2.37212 28.3638H2.37073L7.00468 36.8098C7.0898 36.9633 7.2991 36.9633 7.38143 36.8098L16.8391 19.5759L5.69026 22.721ZM16.8391 45.941H26.1056C26.2731 45.941 26.3777 45.7498 26.294 45.5977L16.8391 28.3638V45.941ZM13.8503 40.0945C13.807 40.2703 13.8293 40.4573 13.9158 40.6163L16.8391 45.941V28.3638L13.8503 40.0945ZM24.0712 32.7577L32.2326 41.3447C32.354 41.4745 32.52 41.5457 32.6931 41.5457H38.5368L24.0712 32.7577L38.5382 41.5457L43.1707 33.1024C43.2544 32.9503 43.1498 32.7577 42.9824 32.7577H24.0712Z",
    fill: props.outStrokeColor
  }));
});

exports.default = _default;